import { render, staticRenderFns } from "./CityMap.vue?vue&type=template&id=56a5853d&scoped=true"
import script from "./CityMap.vue?vue&type=script&lang=js"
export * from "./CityMap.vue?vue&type=script&lang=js"
import style0 from "./CityMap.vue?vue&type=style&index=0&id=56a5853d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a5853d",
  null
  
)

export default component.exports